import React from 'react';
import './Error404Page.css';


export const Error404Page = () => (
  <div className="error404">
    <div className="error404__content">
      <div className="error404__message-wrapper">
        <div className="error404__message">
          <div className="error404__title">Oops!</div>
          <div className="error404__text">Looks like you tried to view a building you don&apos;t have access to...</div>
          <div className="error404__text">Please click the back button in your browser and try again.</div>
        </div>
      </div>
    </div>
  </div>
);
